module.exports = __webpack_public_path__ + "img/zec.b6d880e4.svg";